
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SyncRepoAlert',
  data() {
    return { repoToSync: '' }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    initialRepoName: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  /**
   * Created hook for the component.
   * Sets inital value for repoTosSync data property based on prop value passed.

   * @returns {void}
   */
  created(): void {
    this.repoToSync = this.initialRepoName
  }
})
